import { jsx as _jsx } from "react/jsx-runtime";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { DayPicker } from "react-day-picker";
import { cn } from "../../lib/utils";
import { buttonVariants } from "./button";
function Calendar({ className, classNames, showOutsideDays = true, ...props }) {
    return (_jsx(DayPicker, { showOutsideDays: showOutsideDays, className: cn("p-3", className), classNames: {
            months: "flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0",
            month: "space-y-4",
            caption: "flex justify-center pt-1 relative items-center",
            caption_label: "text-sm font-medium",
            nav: "space-x-1 flex items-center",
            nav_button: cn(buttonVariants({ variant: "outline" }), "h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100"),
            nav_button_previous: "absolute left-1",
            nav_button_next: "absolute right-1",
            table: "w-full border-collapse space-y-1",
            head_row: "flex",
            head_cell: "text-light-text-muted dark:text-dark-text-muted rounded-md w-9 font-normal text-[0.8rem]",
            row: "flex w-full mt-2",
            cell: "h-9 w-9 text-center text-sm p-0 relative [&:has([aria-selected].day-range-end)]:rounded-r-md [&:has([aria-selected].day-outside)]:bg-light-elevated/50 dark:[&:has([aria-selected].day-outside)]:bg-dark-elevated/50 [&:has([aria-selected])]:bg-purple-50 dark:[&:has([aria-selected])]:bg-purple-500/10 first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md focus-within:relative focus-within:z-20",
            day: cn(buttonVariants({ variant: "ghost" }), "h-9 w-9 p-0 font-normal aria-selected:opacity-100"),
            day_range_end: "day-range-end",
            day_selected: "bg-purple-500 text-white hover:bg-purple-500 hover:text-white focus:bg-purple-500 focus:text-white",
            day_today: "bg-purple-50 dark:bg-purple-500/10 text-purple-600 dark:text-purple-400",
            day_outside: "day-outside text-light-text-muted dark:text-dark-text-muted opacity-50 aria-selected:bg-purple-50/50 dark:aria-selected:bg-purple-500/5 aria-selected:text-purple-700 dark:aria-selected:text-purple-300 aria-selected:opacity-30",
            day_disabled: "text-light-text-muted dark:text-dark-text-muted opacity-50",
            day_range_middle: "aria-selected:bg-purple-50 dark:aria-selected:bg-purple-500/10 aria-selected:text-purple-900 dark:aria-selected:text-purple-100",
            day_hidden: "invisible",
            ...classNames,
        }, components: {
            IconLeft: ({}) => _jsx(ChevronLeft, { className: "h-4 w-4" }),
            IconRight: ({}) => _jsx(ChevronRight, { className: "h-4 w-4" }),
        }, ...props }));
}
Calendar.displayName = "Calendar";
export { Calendar };
